import React from "react";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear(); // gets the current year

  return (
    <footer className="footer text-light pt-5 pb-4">
      <div className="container">
        <div className="row">

          {/* Legal & Policies */}
          <div className="col-md-6 mb-3">
            <h5 className="text-uppercase mb-3">Legal & Policies</h5>
            <ul className="list-unstyled">
              <li><a href="/privacy" className="text-light text-decoration-none">Privacy Policy</a></li>
              <li><a href="/privacy" className="text-light text-decoration-none">CA Privacy Notice</a></li>
              <li><a href="/privacy" className="text-light text-decoration-none">Refund Policy</a></li>
              <li><a href="/privacy" className="text-light text-decoration-none">Terms of Service</a></li>
            </ul>
          </div>

          {/* About Us */}
          <div className="col-md-6 mb-3">
            <h5 className="text-uppercase mb-3">About Us</h5>
            <p>
              At <strong>EZMedServ LLC</strong>, we specialize in consulting, business solutions, sales support, and medical billing services. Our goal is to simplify complex processes and help businesses operate more efficiently. With expertise across multiple sectors, we deliver reliable solutions that drive growth and long-term success.
            </p>
          </div>

        </div>

        {/* Copyright */}
        <div className="row mt-3">
          <div className="col text-center">
            <small>© {currentYear} EZMedServ LLC. All rights reserved.</small>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;